import { render, staticRenderFns } from "./CourierCardPage.vue?vue&type=template&id=bf0e8c3c&scoped=true&"
import script from "./CourierCardPage.vue?vue&type=script&lang=js&"
export * from "./CourierCardPage.vue?vue&type=script&lang=js&"
import style0 from "./CourierCardPage.vue?vue&type=style&index=0&id=bf0e8c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0e8c3c",
  null
  
)

export default component.exports